
import 'angular';
import angularAnimate from 'angular-animate';
import angularMaterial from 'angular-material';
import angularUIRouter from 'angular-ui-router';
import angularTranslate from 'angular-translate';
import angularSanitize from 'angular-sanitize';
import ngMessages from 'angular-messages';
import vcRecaptcha from 'angular-recaptcha';
import ngWebSocket from 'angular-websocket';
import httpAuthInterceptor from 'angular-http-auth'
import ngStorage from 'ngstorage'
import focusIf from 'ng-focus-if'
import base64 from 'angular-base64'

// services
import serverConnector from './service/server-connector/server-connector.module';

import users from './users/users.module';
import instalator from './users/instalator/instalator.module';
import client from './users/client/client.module';
import resource from './users/resource/resource.module';
import forgotPassword from './users/forgot-password/forgot-password.module';
import commons from './commons/commons.module';
import materialConfig from './material-config';


// Project specific style
import './scss/bootstrap.scss'

// Create our demo module
export const ffModule = angular.module('ff', [
  angularMaterial,
  angularAnimate,
  angularUIRouter,
  angularTranslate,
  angularSanitize,
  'base64',
  vcRecaptcha,
  'ngWebSocket',
  httpAuthInterceptor,
  'ngStorage',
  ngMessages,
  focusIf,
  serverConnector,
  users,
  instalator,
  client,
  resource,
  forgotPassword,
  commons
]);

ffModule.config(['$stateProvider', ($stateProvider) => {
  $stateProvider.state('public', {
    url: "/public",
    abstract: true,
    views: {},
  }).state('protected', {
    url: "/protected",
    abstract: true,
    views: {},
    resolve: {
      currentUser: ($q, $state, ROLES, $rootScope, $localStorage, LoginService, authService, $base64) => {
        var deferred = $q.defer();

        if(!$localStorage.loggedUser){
          console.warn('protected state resole - rejecting');
          deferred.reject('AUTH_REQUIRED')
          return deferred.promise;
        }

        if(!$rootScope.auth) {
          setScopeAuth()
        }else {
          deferred.resolve();
        }

        function setScopeAuth(){
          $rootScope.isLoggedin = true;

          try {
            $rootScope.auth = {
              login: $base64.decode($localStorage.loggedUser.login),
              role: $localStorage.loggedUser.role
            }
          }catch(error) {
            console.error('login error', error);
            deferred.reject('AUTH_REQUIRED');
            return;
          }


          // TODO add another roles
          if(LoginService.getCurrentUserWebsocket() == null){
            login();
          } else {
            deferred.resolve();
          }
        }

        function login(){
          var promise = LoginService.login(
            $base64.decode($localStorage.loggedUser.login),
            $base64.decode($localStorage.loggedUser.password),
            $localStorage.loggedUser.role
          );

          promise.then(function(data) {
            authService.loginConfirmed({
              role: $localStorage.loggedUser.role,
              login: data.login,
              password:  $base64.decode($localStorage.loggedUser.password)
            });
            deferred.resolve();
          }, function(reason) {
            console.error('login error', reason);
            deferred.reject('AUTH_REQUIRED')
          });
        }

        return deferred.promise;
      }
    }
  });
}]);

ffModule.run(['$rootScope', '$state', '$localStorage', 'ResourceService', 'ROLES', '$window', '$mdToast', '$base64', 'ProfileService', '$translate', '$timeout',
($rootScope, $state, $localStorage, ResourceService, ROLES, $window, $mdToast, $base64, ProfileService, $translate, $timeout) => {

  var statesForbiddenForLoggedUser = [
    'public.users.start',
    'public.users.login',
    'public.users.client.client-registration',
    'public.users.client.client-login',
    'public.users.instalator.instalator-registration',
    'public.users.instalator.instalator-login' ];

  $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {
      console.error("$stateChangeError: " + error);
      if (error === 'AUTH_REQUIRED') {
        $rootScope.isLoggedin = false;
        $localStorage.loggedUser = null;
        $state.go('public.users.login');
      }
    }
  );

  $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
      if($localStorage.loggedUser && (statesForbiddenForLoggedUser.indexOf(toState.name) != -1)) {
        event.preventDefault();
        if($localStorage.loggedUser.role == ROLES.client) {
          $state.go('protected.users.select-resource');
        }else if($localStorage.loggedUser.role == ROLES.instalator){
          $state.go('protected.users.instalator.shared-resources');
        }else {
          console.error('stateChangeStart() - role ' + $localStorage.loggedUser.role + ' not known');
        }
      }
    }
  );

  $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
      $rootScope.errors = null;
    }
  );

  $rootScope.$on('event:auth-loginConfirmed', function(event, data){
    // console.log('auth-loginConfirmed', $localStorage.loggedUser);
    // console.log('auth-loginConfirmed data', $localStorage.loggedUser);
    $rootScope.isLoggedin = true;

    $localStorage.loggedUser = $localStorage.loggedUser || {};

    $localStorage.loggedUser.login = $base64.encode(data.login);
    $localStorage.loggedUser.password = $base64.encode(data.password);
    $localStorage.loggedUser.role = data.role;

    $rootScope.auth = {
      login: data.login,
      role: data.role
    }

  });

  $rootScope.$on('event:auth-loginCancelled', function(event, data){
    ResourceService.close()
    $rootScope.auth = null;
    $rootScope.isLoggedin = false;
    $localStorage.loggedUser = null;
  });

  $rootScope.$on('server-sendingRequestStart', (event) => {
    // FIXME remove setting mainProgressVisible from other places
    $rootScope.mainProgressVisible = true;
  });

  $rootScope.$on('server-sendingRequestEnd', (event) => {
    // FIXME remove setting mainProgressVisible from other places
    $rootScope.mainProgressVisible = false;
  });

  $rootScope.$on('server-connectionError', (event, data) => {
    $rootScope.errors = data.errors;

    $timeout(function() {$rootScope.errors = null}, 10000);

  });

  $rootScope.$on('server-connectionOk', (event) => {
    $rootScope.errors = null;
  });

  $rootScope.goBack = function(){
    $window.history.back();
  }

  $rootScope.toast = function(text){
    $mdToast.show(
      $mdToast.simple()
        .textContent(text)
        .position('top right')
        .hideDelay(3000)
    );
  };

}]);

ffModule.config(['$translateProvider', function ($translateProvider) {
  $translateProvider.useSanitizeValueStrategy(null);

  $translateProvider.determinePreferredLanguage();
  let lang = localStorage.lang ? localStorage.lang : (navigator.language || navigator.userLanguage);

  //??? szkoda, że dalej nie poszli w tym gównie :D
  if(lang.indexOf('-') > -1) {
    lang = lang.split('-')[0];
  }

  if(lang.indexOf('_') > -1) {
    lang = lang.split('_')[0];
  }

  //set default language to Polish
  if (lang !== 'pl' || lang !== 'en')
    lang = 'pl';

  localStorage.lang = lang;
  $translateProvider
    .translations('pl', require('../locale/pl.json'))
    .translations('en', require('../locale/en.json'))
    .preferredLanguage(lang)
    .useMissingTranslationHandler('MissingTranslationHandler');
}]);

ffModule.config(['$mdThemingProvider', function ($mdThemingProvider) {
  materialConfig($mdThemingProvider);
}]);

ffModule.factory('MissingTranslationHandler', function ($translate) {
  return function (translationID, uses) {
    console.log('MissingTranslationHandler', translationID, uses);
    return $translate.instant('ERROR.UNEXPECTED');
  };
});


ffModule.controller('MainController', function($rootScope, $scope, authService, $localStorage, $state, $window) {
  $scope.openProfileMenu = function($mdMenu, ev) {
    $mdMenu.open(ev);
  };

  $scope.logout = function(){
    authService.loginCancelled();
    $window.location.reload();
  };

  $scope.errorsContais = function (error) {
    return $rootScope.errors && $rootScope.errors.indexOf(error) !== -1
  }

});



// WEBPACK FOOTER //
// ./src/index.js